import moment from 'moment';

function customDate($input, params) {
    const formatParam = "YYYY-MM-DD";
    const format = "DD/MM/YYYY";

    let pickerparams = {
        "autoApply": true,
        "autoUpdateInput": false,
        "opens": "right",
        "locale": {
            "format": format
          },
        "minDate": params.minDate,
        "maxDate": params.maxDate,
        "alwaysShowCalendars": true,
        "singleDatePicker": true
    };

	const $wrapper = $input.parents('.form-group');
    const id = $input.attr('id');

    $input.after('<span class="date-label"><span class="value"></span><i class="fa-regular fa-calendar"></i></span>');

    $wrapper.on('click', '.date-label', function() {
        $input.click();
    });

    const updateDateControlFunc = function($control, newDate) {
        $control.val(newDate.format(formatParam));
        $control.next().find('.value').html(newDate.format(format));
    };

    updateDateControlFunc($input, moment($input.val()));

    $input.daterangepicker(pickerparams, function(start, end, label) {
        updateDateControlFunc($input, start);
    });
}

export default customDate;
